import { EditOutlined } from '@ant-design/icons';
import { Button, Flex, Tooltip } from 'antd';
import moment from 'moment';

import type {
  ModelWarehouseInventory,
  ModelWarehouseInventoryState,
} from '@app/api/WarehouseInventories';
import { statusTitles } from '@app/pages/Warehouses/Inventory/data/constants';
import type { GetColumnType } from '@app/pages/Warehouses/Inventory/types';

import type { ColumnsType } from 'antd/es/table';

export const getInventoryColumns: GetColumnType = ({
  onOpen,
  onEdit,
  IsInventoryEdit,
  showOpenInventoryButton,
}) => {
  const columns: ColumnsType<ModelWarehouseInventory> = [
    {
      title: '№',
      dataIndex: 'Id',
      key: 'Id',
      width: 56,
    },
    {
      title: 'Склад',
      dataIndex: 'Warehouse',
      key: 'Warehouse',
      width: 200,
      render: (text) => (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Создано',
      dataIndex: 'TimeCreated',
      key: 'TimeCreated',
      width: 150,
      render: (date) => (
        <span className="no-wrap-text">
          {moment(date).format('DD.MM.YYYY HH:mm')}
        </span>
      ),
    },
    {
      title: 'Автор',
      dataIndex: 'UserName',
      key: 'UserName',
      width: 160,
      ellipsis: true,
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Статус',
      dataIndex: 'State',
      key: 'State',
      width: 120,
      render: (status: ModelWarehouseInventoryState) => (
        <span className="no-wrap-text">{statusTitles[status]}</span>
      ),
    },
    {
      title: 'Заполнено, %',
      dataIndex: 'CountFilled',
      key: 'CountFilled',
      width: 120,
    },
    {
      title: 'Комментарий',
      dataIndex: 'Comment',
      key: 'Comment',
      width: 240,
      render: (text) => (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
          {text}
        </span>
      ),
    },
    {
      title: null,
      key: 'actions',
      width: 140,
      fixed: 'right',
      render: (_: unknown, row: ModelWarehouseInventory) => (
        <Flex gap={8} justify="start" align="center">
          {showOpenInventoryButton(row) && (
            <Button onClick={() => onOpen(row?.Id)}>Открыть</Button>
          )}
          {IsInventoryEdit && row?.State !== 'done' && (
            <Tooltip title="Редактировать">
              <Button icon={<EditOutlined />} onClick={() => onEdit(row?.Id)} />
            </Tooltip>
          )}
        </Flex>
      ),
    },
  ];

  return columns;
};
